import {Card} from 'react-bootstrap';
import React from 'react';
import {type BootStrapProps} from '../../Bootstrap';

export type BootStrapCardBodyProps =  BootStrapProps;
export const BootstrapCardBody = (props: BootStrapCardBodyProps) => <Card.Body {...props as any} />;
